import { getErrorCode, getErrorStatus, getErrorText } from '../../../../common/api/errors'
import { ROUTING_ERROR_TEXT } from './labels'

const FALLBACK = 'Не удалось выполнить запрос.'

/**
 * Human-readable message of a failed routing request (priorities, their configuration, coverage): the text of
 * its code, the fixed 403 / 503 texts, the backend sentence, the field errors, then the thrown error's message.
 */
export const routingErrorText = (err: unknown): string => {
  const code = getErrorCode(err)
  if (code && ROUTING_ERROR_TEXT[code]) return ROUTING_ERROR_TEXT[code]
  if (getErrorStatus(err) === undefined) {
    return err instanceof Error && err.message ? err.message : FALLBACK
  }

  return getErrorText(err, FALLBACK)
}
